// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"94165f2d","323":"80d18b4c","332":"9e0695b5","375":"30524f64","421":"ba26527a","451":"7c2110db","453":"c1817f12","496":"92802c31","516":"34bdea00","591":"cb922910","619":"70bb2d55","685":"2519d50c","773":"ea0e9610","857":"3540b295","959":"cd9d51a2"}[chunkId] + ".chunk.js";
};